import { earliestDelivery, deliveryError, orderMethodHelp } from '@theme/dew-delivery-rules';
class DewDeliveryDate extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.input = this.querySelector('input[type="date"]');
    this.hint = this.querySelector('.__hint');
    this.method = this.querySelector('[data-order-method]');
    this.rules = { cutoff: Number(this.dataset.cutoffHour || 11), pickupCutoff: Number(this.dataset.pickupCutoffHour || 15), method: this.method?.value || 'Delivery', lead: Number(this.dataset.leadDays || 0), closed: (this.dataset.closedDays || '').split(',').filter(Boolean).map(Number) };
    this.input.min = earliestDelivery(new Date(), this.rules);
    if (!this.input.value) { this.input.value = this.input.min; this.autoDate = this.input.value; }
    this.input.addEventListener('change', () => { this.autoDate = null; this.validate(); }, options);
    this.method?.addEventListener('change', () => {
      this.rules.method = this.method.value;
      if (this.autoDate && this.input.value === this.autoDate) {
        this.input.value = earliestDelivery(new Date(), this.rules); this.autoDate = this.input.value;
      }
      this.validate();
    }, options);
    window.addEventListener('focus', () => this.validate(), options);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.validate(); }, options);
    // Capture at document level before the product component serializes the form.
    document.addEventListener('submit', event => {
      if (event.target === this.input.form && !this.validate()) {
        event.preventDefault(); event.stopImmediatePropagation(); this.input.reportValidity(); this.input.focus();
      }
    }, { ...options, capture: true });
    this.timer = setInterval(() => this.validate(), 30000);
    this.validate();
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; clearInterval(this.timer); }
  validate() {
    if (this.method) this.rules.method = this.method.value;
    const help = this.querySelector('[data-method-help]');
    if (help) help.textContent = orderMethodHelp(this.rules);
    this.input.min = earliestDelivery(new Date(), this.rules);
    const message = this.input.value || this.input.required ? deliveryError(this.input.value, new Date(), this.rules) : '';
    this.input.setCustomValidity(message);
    this.input.toggleAttribute('aria-invalid', Boolean(message));
    if (message) this.input.setAttribute('aria-invalid', 'true');
    this.hint.textContent = message; this.hint.hidden = !message; this.hint.toggleAttribute('data-error', Boolean(message));
    return !message;
  }
}
if (!customElements.get('dew-delivery-date')) customElements.define('dew-delivery-date', DewDeliveryDate);
